import SearchIconActive from 'images/svg/Icon feather-search.svg';
import SearchIcon from 'images/svg/Icon feather-search (1).svg';
import ApplicationIcon from 'images/svg/applicationIcon.svg';
import ProfileIcon from 'images/svg/profileIcon.svg';
import classNames from './job-board-menu.module.css';
import {useHistory} from 'react-router-dom';
import {useTranslation} from 'react-i18next';

const JobBoardMenuMobileView = ({active}) => {
  const history = useHistory();
  const {t} = useTranslation();

  async function handleRedirect(type) {
    if (type === 'jobList') {
      history.push({
        pathname: `/internal/jobboard`,
      });
    } else if (type === 'applied') {
      history.push({
        pathname: `/jobboard/applied`,
      });
    } else if (type === 'profile') {
      history.push({
        pathname: `/jobboard/profile`,
      });
    }
  }

  return (
    <>
      <div
        className={`${
          active == 'search-job' ? classNames['menu-item-mv-items-active'] : ''
        } ${classNames['menu-item-mv-items']}`}
        onClick={() => {
          handleRedirect('jobList');
        }}
      >
        <img src={active == 'search-job' ? SearchIconActive : SearchIcon}></img>
        <div>{t('Search')}</div>
      </div>
      <div
        className={`${
          active == 'application' ? classNames['menu-item-mv-items-active'] : ''
        } ${classNames['menu-item-mv-items']}`}
        onClick={() => {
          handleRedirect('applied');
        }}
      >
        <img src={ApplicationIcon}></img>
        <div>{t('Application')}</div>
      </div>
      <div
        className={`${
          active == 'profile' ? classNames['menu-item-mv-items-active'] : ''
        } ${classNames['menu-item-mv-items']}`}
        onClick={() => {
          handleRedirect('profile');
        }}
      >
        <img src={ProfileIcon}></img>
        <div>{t('Job_Board_Menu_Profile')}</div>
      </div>
    </>
  );
};

export default JobBoardMenuMobileView;
